"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dict = void 0;
var Dict = /** @class */ (function () {
    function Dict(_dict) {
        if (_dict === void 0) { _dict = {}; }
        this._dict = _dict;
    }
    Dict.prototype.get = function (key, language) {
        if (!key)
            return '';
        var item = this._dict[key];
        if (!item || !language)
            return item || '';
        return item[language] || '';
    };
    Dict.prototype.to_resources = function () {
        return Object.entries(this._dict).reduce(function (acc, _a) {
            var key = _a[0], item = _a[1];
            Object.entries(item).forEach(function (_a) {
                var language = _a[0], translation = _a[1];
                if (!translation || !acc[language])
                    return;
                acc[language].translation[key] = translation;
            });
            return acc;
        }, {
            zh: { translation: {} },
            en: { translation: {} },
            ja: { translation: {} },
            ko: { translation: {} },
        });
    };
    return Dict;
}());
exports.Dict = Dict;
exports.default = Dict;
//# sourceMappingURL=dict.js.map